export interface IPreviewToken {
    token: string;
    url: string;
    expiry: string;
    check_expiry: boolean;
}
type FetchTokenFn = (tenantId?: string, container?: string) => Promise<IPreviewToken>;

let fetchToken: FetchTokenFn | null = null;

export const registerPreviewTokenFetcher = (fn: FetchTokenFn) => {
    fetchToken = fn;
};

export const getPreviewTokenFetcher = () => {
    if (!fetchToken) {
        throw new Error("Preview token fetcher not registered");
    }
    return fetchToken;
};